import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-stone-50 px-5 pb-20 pt-10 sm:pt-14" data-id="element-106" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-107" data-mp="9lbkteco9zjx">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-4xl font-bold leading-[1.05] tracking-tight text-stone-900 sm:text-5xl md:text-6xl" data-id="element-108" data-mp="4m8m0bnacpke">
          Solve a Full Year of Math Class in Just{' '}
          <span className="text-orange-600" data-id="element-109" data-mp="s9q75oc1opee">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-stone-600 sm:mt-6 sm:text-lg" data-id="element-110" data-mp="nb6ktmtjhbli">
          Join 2,000+ math teachers who stopped improvising. Walk into every
          class with everything ready to teach, solve, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-8 max-w-2xl" data-id="element-111" data-mp="3o59bpicfn4e0">
          <img src="https://cdn.magicpatterns.com/uploads/aJ5hqaN3VeNSMELHiz1KVt/5d7d771c-a6b7-407e-9daf-232b532d381a.webp" alt="The Math Ready pack shown across printed volumes, desktop, tablet and phone" className="w-full" data-id="element-112" data-mp="30hrev8eb9g46" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="mt-6" data-id="element-113" data-mp="2vi53l4i1m9y0">
          <CtaButton href="#offer" data-id="element-114" data-mp="2ljpa4uvjmolc" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-medium text-stone-500 sm:text-sm" data-id="element-115" data-mp="2lmv0sejtlyj6">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-116" data-mp="na08cwk1yzd4" data-mpi={index}>
                <span data-id="element-117" data-mp="id9u8ert6duc">{item}</span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-stone-300" data-id="element-118" data-mp="ddwxn2b4xsek">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}